/* sts-chrome.js — behaviour for the v4 global chrome.
 *
 * Spec: docs/new-theme-v4/specs/03-homepage-global-chrome-spec.md
 *       §3.5 (window.STS.chrome), §7.1 (hide on scroll), §7.4 (affiliate
 *       colours), §7.5 (the typed link), AC 3-4, 19-21, 29-33.
 *
 * What is deliberately NOT here: anything that decides what the first frame
 * looks like. The session state, the type ramp, which state strip shows, which
 * mega-menu column 3 renders and which announcement group loops are all
 * resolved before the first paint — by snippets/sts-head-state.liquid on <html>
 * and by CSS. This file only handles interaction, and the page is correct with
 * it disabled.
 *
 * Load deferred. It tolerates sts:state arriving late and re-runs the two
 * things that depend on it.
 */
(function () {
  'use strict';

  var d = document;
  var root = d.documentElement;
  var STS = (window.STS = window.STS || {});

  if (STS.chromeBooted) return;
  STS.chromeBooted = true;

  /* A function, not a value read once at load. This file is deferred and lives
     for the whole page, and the announcement rotator below keys its default
     paused state off it — read once, a visitor who turns reduced motion on
     mid-session kept a bar that rotates until they reload. Matches the helpers
     in assets/sts-ui.js and assets/sts-home.js, which re-query per call. */
  function reduceMotion() {
    try {
      return !!(window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    } catch (e) { return false; }
  }

  function $(sel, ctx) { return (ctx || d).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || d).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts); }

  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),' +
    'textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

  /* What is open, so that the header knows not to hide (AC 4) and so that one
     open thing closes another. */
  var openThing = null;      // 'drawer' | 'search' | 'mega' | 'badge'
  var lastFocus = null;

  function markOpen(name) {
    openThing = name;
    if (name) root.setAttribute('data-sts-chrome-open', name);
    else root.removeAttribute('data-sts-chrome-open');
  }

  // ------------------------------------------------------------- the header

  var header = $('[data-sts-header]');

  /* Hide on scroll down, show on any scroll up. Threshold 120px so the header
     never flickers on a short overscroll, and never while something is open. */
  (function hideOnScroll() {
    if (!header || header.getAttribute('data-sts-sticky') !== 'hide_on_scroll') return;
    var last = window.pageYOffset || 0;
    var ticking = false;

    function update() {
      ticking = false;
      var y = window.pageYOffset || 0;
      if (openThing) { header.setAttribute('data-hidden', 'false'); last = y; return; }
      if (y > last && y > 120) header.setAttribute('data-hidden', 'true');
      else if (y < last) header.setAttribute('data-hidden', 'false');
      last = y;
    }

    on(window, 'scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }, { passive: true });
  }());

  // ------------------------------------------------------------ the drawer

  var drawer = $('[data-sts-drawer]');
  var scrim = $('[data-sts-scrim]');
  var hamburger = $('[data-sts-drawer-open]');

  function trapFocus(ev) {
    if (ev.key !== 'Tab' || !drawer || openThing !== 'drawer') return;
    var items = $$(FOCUSABLE, drawer).filter(function (el) { return el.offsetParent !== null; });
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (ev.shiftKey && d.activeElement === first) { ev.preventDefault(); last.focus(); }
    else if (!ev.shiftKey && d.activeElement === last) { ev.preventDefault(); first.focus(); }
  }

  function openDrawer() {
    if (!drawer) return;
    lastFocus = d.activeElement;
    // v6.1 1.5b: By product type / By skin concern start closed on every open.
    $$('[data-sts-drawer-sub]', drawer).forEach(function (x) { x.open = false; });
    root.setAttribute('data-sts-drawer', 'open');
    markOpen('drawer');
    if (hamburger) hamburger.setAttribute('aria-expanded', 'true');
    drawer.focus();
  }

  function closeDrawer() {
    if (!drawer) return;
    root.removeAttribute('data-sts-drawer');
    if (openThing === 'drawer') markOpen(null);
    if (hamburger) hamburger.setAttribute('aria-expanded', 'false');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
    lastFocus = null;
  }

  on(hamburger, 'click', openDrawer);
  on($('[data-sts-drawer-close]'), 'click', closeDrawer);
  /* v6.2 §2.3: a link in the menu closes it as it goes (the logo: "closes the
     menu and goes home"), so a same-page link (My rewards on the Skin
     Profile) is not left under it and Back never restores it open. */
  on(drawer, 'click', function (ev) { if (ev.target.closest && ev.target.closest('a[href]')) closeDrawer(); });
  on(scrim, 'click', closeDrawer);
  on(d, 'keydown', trapFocus);

  // ------------------------------------------------------ the search panel

  var searchPanel = $('[data-sts-search-panel]');
  var searchToggle = $('[data-sts-search-open]');
  var searchInput = searchPanel ? $('input[name="q"]', searchPanel) : null;

  /* Boost swaps our placeholder for "Search" when it binds. Put ours back,
     at most three times, so a Boost that insists wins rather than loops. The
     phone gets the short one: asset-notes/sts-chrome-js.md, "placeholder". */
  var ph = searchInput && searchInput.getAttribute('data-sts-placeholder');
  var phM = searchInput && searchInput.getAttribute('data-sts-placeholder-m');
  var phMq = phM && window.matchMedia ? window.matchMedia('(max-width: 860px)') : null;
  if (ph && window.MutationObserver) {
    var phLeft = 3;
    var phFix = function () {
      var want = phMq && phMq.matches ? phM : ph;
      if (searchInput.placeholder !== want && phLeft-- > 0) searchInput.placeholder = want;
    };
    new MutationObserver(phFix).observe(searchInput, { attributes: true, attributeFilter: ['placeholder'] });
    phFix();
    if (phMq) {
      var phBp = function () { phLeft++; phFix(); };
      if (phMq.addEventListener) phMq.addEventListener('change', phBp);
      else if (phMq.addListener) phMq.addListener(phBp);
    }
  }

  /* In the bar at every width (a phone gives it its own row), so never inert.
     See asset-notes/sts-chrome-js.md. */
  function searchInline() { return true; }
  function setSearch(open) {
    if (!header || !searchPanel) return;
    var overlay = open && !searchInline();
    if (overlay) {
      closeMega();
      closeBadge();
      header.setAttribute('data-search', 'open');
      searchPanel.removeAttribute('inert');
      markOpen('search');
    } else {
      header.removeAttribute('data-search');
      if (searchInline()) searchPanel.removeAttribute('inert');
      else searchPanel.setAttribute('inert', '');
      if (openThing === 'search') markOpen(null);
    }
    if (open && searchInput) searchInput.focus();
    if (searchToggle) searchToggle.setAttribute('aria-expanded', overlay ? 'true' : 'false');
  }
  setSearch(false);
  on(searchToggle, 'click', function () { setSearch(openThing !== 'search'); });

  /* An empty submit used to send the shopper to /search with no terms, where the
     results app has nothing to render and leaves its loading skeleton on screen
     — a page that looks broken, reached by pressing Enter on an empty box. The
     submit is simply refused and focus stays in the field. Not `required`: that
     hands the browser a validation bubble on a control the shopper may have
     opened just to look at, and the bubble copy is not ours. */
  var searchForm = searchPanel ? $('form', searchPanel) : null;
  on(searchForm, 'submit', function (ev) {
    if (!searchInput) return;
    if (String(searchInput.value || '').trim()) return;
    ev.preventDefault();
    searchInput.focus();
  });

  // ------------------------------------------ Boost's mobile search takeover

  /* Phone only: Boost answers the field's focus with its own full-screen search,
     empty until typed. Why and what we add: asset-notes/sts-chrome-js.md. */

  var BOOST_M = '.boost-sd__search-bar-wrapper--mobile';
  var boostSeek = null;    // observer waiting for the overlay to appear
  var boostLive = null;    // observer watching an open overlay for its close

  function boostBarInput(w) { return $('.boost-sd__search-bar-input', w); }

  /* Boost's bar is a controlled React input: assigning .value leaves its state
     untouched and the keystroke never happens. The prototype's own setter plus
     an `input` event is what React listens to. */
  function typeInto(input, term) {
    try {
      var desc = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value');
      if (desc && desc.set) desc.set.call(input, term);
      else input.value = term;
    } catch (e) { input.value = term; }
    input.dispatchEvent(new Event('input', { bubbles: true }));
  }

  function syncPopular(w) {
    var box = $('[data-sts-msearch]', w);
    var input = boostBarInput(w);
    if (!box || !input) return;
    box.hidden = !!String(input.value || '').trim();
  }

  function paintPopular(w) {
    if ($('[data-sts-msearch]', w)) return;
    var raw = searchPanel && searchPanel.getAttribute('data-sts-search-popular');
    var terms = String(raw || '').split(',').map(function (t) { return t.trim(); })
      .filter(Boolean).slice(0, 8);
    if (!terms.length) return;

    var box = d.createElement('div');
    box.className = 'sts-msearch';
    box.setAttribute('data-sts-msearch', '');

    var lead = d.createElement('p');
    lead.className = 'sts-msearch__lead';
    lead.textContent = 'Popular searches';
    box.appendChild(lead);

    var list = d.createElement('ul');
    list.className = 'sts-msearch__list';
    terms.forEach(function (term) {
      var li = d.createElement('li');
      var btn = d.createElement('button');
      btn.type = 'button';
      btn.className = 'sts-msearch__chip';
      btn.textContent = term;
      li.appendChild(btn);
      list.appendChild(li);
    });
    box.appendChild(list);
    w.appendChild(box);

    on(box, 'click', function (ev) {
      var chip = ev.target && ev.target.closest && ev.target.closest('.sts-msearch__chip');
      if (!chip) return;
      var input = boostBarInput(w);
      if (!input) return;
      input.focus();
      typeInto(input, chip.textContent);
      syncPopular(w);
    });
    on(w, 'input', function () { syncPopular(w); });
    syncPopular(w);
  }

  /* Not offsetParent: the wrapper is position:fixed, and offsetParent is null
     for a fixed element whether it is on screen or not. */
  function boostOpen() {
    var w = $(BOOST_M);
    if (!w || !w.isConnected) return null;
    var s = window.getComputedStyle(w);
    return (s.display === 'none' || s.visibility === 'hidden') ? null : w;
  }

  function closeBoost() {
    var w = boostOpen();
    if (!w) return false;
    /* Boost's own control: it is what gives the body its scroll back. */
    var x = $('[data-group="close-search-form"]', w);
    if (x) x.click();
    return true;
  }

  function adoptBoost(w) {
    paintPopular(w);
    if (boostLive) boostLive.disconnect();
    if (!window.MutationObserver) return;
    /* Boost closes it by hiding it, or by removing it; watch for both. */
    boostLive = new MutationObserver(function () {
      if (boostOpen()) return;
      boostLive.disconnect();
      boostLive = null;
      if (searchToggle) searchToggle.focus();
    });
    boostLive.observe(w.parentNode || d.body,
      { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] });
  }

  /* Built on demand, so the watch starts on our trigger and stops as soon as it
     finds one — or after four seconds, if Boost never takes over (desktop, or
     the app failing to load). */
  function watchBoost() {
    if (boostSeek || !window.MutationObserver) return;
    var stop = function () { if (boostSeek) { boostSeek.disconnect(); boostSeek = null; } };
    boostSeek = new MutationObserver(function () {
      var w = boostOpen();
      if (!w) return;
      stop();
      adoptBoost(w);
    });
    boostSeek.observe(d.body, { childList: true, subtree: true });
    setTimeout(stop, 4000);
    var now = boostOpen();
    if (now) { stop(); adoptBoost(now); }
  }
  on(searchToggle, 'click', watchBoost);
  on(searchInput, 'focus', watchBoost);

  // ---------------------------------------------------------- the mega menu

  /* Hover intent, one shell, cross-fade, one overlay at a time. Why each
     number is what it is: asset-notes/sts-chrome-js.md, "mega menus". */
  var megaTriggers = $$('[data-sts-mega-toggle]');
  var megaOpenId = null;
  var megaTimer = null;
  var megaHideT = {};
  var megaPointer = false;
  var MEGA_OPEN_MS = 120;
  var MEGA_CLOSE_MS = 250;
  var MEGA_OUT_MS = 120;
  var fineHover = window.matchMedia ? window.matchMedia('(hover: hover) and (pointer: fine)') : null;
  function canHover() { return !!(fineHover && fineHover.matches); }

  function megaPanel(t) { return d.getElementById(t.getAttribute('aria-controls')); }
  function clearMegaTimer() { clearTimeout(megaTimer); megaTimer = null; }
  function megaLater(fn, ms) {
    clearMegaTimer();
    megaTimer = setTimeout(function () { megaTimer = null; fn(); }, ms);
  }

  /* Boost's desktop suggestions (z 999999998) are closed the way Boost's own
     close does it (cr() in bc-widget-integration.js 1.40.2): the class its
     visibility test reads, and the state its reopen path resets. */
  function quietSearch() {
    if (searchInput && d.activeElement === searchInput) searchInput.blur();
    var w = $('.boost-sd__instant-search-container-desktop > div') || $('.boost-sd__search-widget-init-wrapper');
    if (!w || w.classList.contains('boost-sd__g-hide')) return;
    w.classList.add('boost-sd__g-hide');
    w.setAttribute('aria-controls', '');
    d.body.classList.remove('boost-sd__g-no-scroll', 'boost-sd__search-opening');
    if (searchInput) searchInput.setAttribute('aria-expanded', 'false');
  }

  function settle(p) {
    p.removeAttribute('data-leaving');
    if (!p.hasAttribute('data-open')) p.hidden = true;
  }

  function showPanel(p, swap) {
    clearTimeout(megaHideT[p.id]);
    p.removeAttribute('data-leaving');
    p.hidden = false;
    if (swap) p.setAttribute('data-swap', '');
    else p.removeAttribute('data-swap');
    void p.offsetWidth;
    p.setAttribute('data-open', '');
  }

  function hidePanel(p, now) {
    p.removeAttribute('data-open');
    clearTimeout(megaHideT[p.id]);
    if (p.hidden) return;
    if (now || reduceMotion()) { settle(p); return; }
    megaHideT[p.id] = setTimeout(function () { settle(p); }, MEGA_OUT_MS);
  }

  /* Trigger to trigger: the outgoing content goes in the same frame (never two
     panels painted at once), the incoming shell grows or shrinks from its
     height and the incoming content fades in. */
  var megaHeightT = null;
  function swapPanels(from, to) {
    var h0 = from.offsetHeight;
    hidePanel(from, true);
    showPanel(to, true);
    if (reduceMotion()) return;
    var h1 = to.offsetHeight;
    if (h0 === h1) return;
    clearTimeout(megaHeightT);
    to.style.height = h0 + 'px';
    void to.offsetWidth;
    to.style.height = h1 + 'px';
    megaHeightT = setTimeout(function () { to.style.height = ''; }, 200);
  }

  function closeMega() {
    clearMegaTimer();
    megaTriggers.forEach(function (t) {
      t.setAttribute('aria-expanded', 'false');
      var p = megaPanel(t);
      if (p) hidePanel(p);
    });
    megaOpenId = null;
    if (openThing === 'mega') markOpen(null);
  }

  function openMega(id) {
    clearMegaTimer();
    closeBadge();
    quietSearch();
    var trigger = null;
    var from = null;
    var to = null;
    megaTriggers.forEach(function (t) {
      var mine = t.getAttribute('data-sts-mega-toggle') === id;
      t.setAttribute('aria-expanded', mine ? 'true' : 'false');
      var p = megaPanel(t);
      if (mine) trigger = t;
      if (!p) return;
      if (mine) { if (!p.hasAttribute('data-open')) to = p; }
      else if (p.hasAttribute('data-open')) from = p;
      else hidePanel(p, true);
    });
    if (to && from) swapPanels(from, to);
    else if (to) showPanel(to, false);
    else if (from) hidePanel(from);
    megaOpenId = trigger ? id : null;
    if (trigger) markOpen('mega');
    return trigger;
  }

  function megaIn(id) {
    megaPointer = true;
    if (megaOpenId === id) clearMegaTimer();
    else megaLater(function () { openMega(id); }, MEGA_OPEN_MS);
  }
  function megaOut() {
    megaPointer = false;
    if (megaOpenId === null) clearMegaTimer();
    else megaLater(closeMega, MEGA_CLOSE_MS);
  }
  function mouseOnly(fn) {
    return function (ev) { if (ev.pointerType !== 'touch' && canHover()) fn(); };
  }

  /* Focus left the open trigger and its panel. Tab past the last link lands
     on the next trigger, which is still inside the header. */
  function megaHas(el) {
    if (!megaOpenId || !el) return false;
    var t = $('[data-sts-mega-toggle="' + megaOpenId + '"]');
    var p = t && megaPanel(t);
    return !!(t && (t.contains(el) || (p && p.contains(el))));
  }
  function megaFocusOut(ev) {
    if (!megaOpenId) return;
    if (ev.relatedTarget) { if (!megaHas(ev.relatedTarget)) closeMega(); return; }
    window.requestAnimationFrame(function () {
      if (!d.hasFocus() || megaPointer) return;
      if (!megaHas(d.activeElement)) closeMega();
    });
  }

  var megaPointerType = '';
  megaTriggers.forEach(function (t) {
    var id = t.getAttribute('data-sts-mega-toggle');
    var p = megaPanel(t);
    on(t, 'pointerdown', function (ev) { megaPointerType = ev.pointerType || ''; });
    /* Mouse: open, never toggle shut (the click lands after hover opened it).
       Keyboard (detail 0) and touch toggle. A link trigger (Library, Sale)
       behaves the same and only navigates on a modified click; its panel
       carries the link to the page. */
    on(t, 'click', function (ev) {
      if (ev.metaKey || ev.ctrlKey || ev.shiftKey) return;
      ev.preventDefault();
      var kb = ev.detail === 0;
      var touch = !kb && (megaPointerType === 'touch' || !canHover());
      megaPointerType = '';
      if (!kb && !touch) openMega(id);
      else if (megaOpenId === id) closeMega();
      else openMega(id);
    });
    on(t, 'keydown', function (ev) {
      if (ev.key !== 'ArrowDown' && ev.key !== 'Down') return;
      ev.preventDefault();
      if (megaOpenId !== id) openMega(id);
      var first = p && $(FOCUSABLE, p);
      if (first) first.focus();
    });
    on(t, 'pointerenter', mouseOnly(function () { megaIn(id); }));
    on(t, 'pointerleave', mouseOnly(megaOut));
    on(t, 'focusout', megaFocusOut);
    if (p) {
      on(p, 'pointerenter', mouseOnly(function () {
        megaPointer = true;
        if (megaOpenId === id) clearMegaTimer();
      }));
      on(p, 'pointerleave', mouseOnly(megaOut));
      on(p, 'focusout', megaFocusOut);
    }
  });

  /* Focusing the search closes every header menu. */
  on(searchPanel, 'focusin', function () {
    if (megaOpenId) closeMega();
    closeBadge();
  });

  if (header) {
    /* Tabbing off the header entirely; the drawer is modal and not here. */
    on(header, 'focusout', function (ev) {
      if (openThing !== 'mega' && openThing !== 'badge' && openThing !== 'search') return;
      if (!ev.relatedTarget || header.contains(ev.relatedTarget)) return;
      closeMega();
      closeBadge();
      setSearch(false);
    });
  }

  // --------------------------------------------------------- the badge menu

  var badgeToggle = $('[data-sts-badge-toggle]');
  var badgeMenu = $('[data-sts-badge-menu]');

  function closeBadge() {
    if (!badgeMenu) return;
    badgeMenu.hidden = true;
    if (badgeToggle) badgeToggle.setAttribute('aria-expanded', 'false');
    if (openThing === 'badge') markOpen(null);
  }

  on(badgeToggle, 'click', function () {
    if (!badgeMenu) return;
    var open = badgeMenu.hidden;
    /* One popover at a time. Without this, opening the badge menu only
       reassigned openThing, so an already-open mega panel stayed on screen with
       aria-expanded="true" and Escape then closed the wrong one. */
    if (open) { closeMega(); setSearch(false); quietSearch(); }
    badgeMenu.hidden = !open;
    badgeToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    markOpen(open ? 'badge' : null);
  });

  // -------------------------------------------------- one Escape, one close

  on(d, 'keydown', function (ev) {
    if (ev.key !== 'Escape' && ev.key !== 'Esc') return;
    /* Boost's full-screen search is over everything else, so it is the first
       thing Escape should reach. It does not listen for the key itself. */
    if (closeBoost()) return;
    if (openThing === 'drawer') closeDrawer();
    else if (openThing === 'search') { setSearch(false); if (searchToggle) searchToggle.focus(); }
    else if (openThing === 'mega') {
      var t = d.querySelector('[data-sts-mega-toggle][aria-expanded="true"]');
      closeMega();
      if (t) t.focus();
    } else if (openThing === 'badge') { closeBadge(); if (badgeToggle) badgeToggle.focus(); }
  });

  /* A click anywhere outside closes the popovers, but never the drawer, which
     has its own scrim. */
  on(d, 'click', function (ev) {
    if (openThing !== 'badge' && openThing !== 'mega' && openThing !== 'search') return;
    if (header && header.contains(ev.target)) return;
    closeBadge();
    closeMega();
    setSearch(false);
  }, true);

  // ------------------------------------------------- announcement bar pause

  $$('[data-sts-ann]').forEach(function (bar) {
    var btn = $('[data-sts-ann-pause]', bar);
    if (!btn) return;
    var stored = null;
    try { stored = localStorage.getItem('stsAnnPaused'); } catch (e) { /* blocked storage */ }
    var paused = stored === '1' || reduceMotion();

    function apply() {
      bar.setAttribute('data-paused', paused ? 'true' : 'false');
      btn.setAttribute('aria-label', btn.getAttribute(paused ? 'data-label-play' : 'data-label-pause'));
    }
    apply();

    on(btn, 'click', function () {
      paused = !paused;
      try { localStorage.setItem('stsAnnPaused', paused ? '1' : '0'); } catch (e) { /* blocked storage */ }
      apply();
    });

    /* Turning reduced motion on mid-session stops the bar there and then. The
       CSS block in assets/sts-chrome.css already does this for the animation;
       this keeps the pause BUTTON's label honest, which is the half CSS cannot
       reach. A visitor who has explicitly pressed play is left alone — their
       stored choice is a deliberate answer to this same question. */
    try {
      var mq = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
      if (mq && mq.addEventListener) {
        mq.addEventListener('change', function (ev) {
          var choice = null;
          try { choice = localStorage.getItem('stsAnnPaused'); } catch (e) { /* blocked storage */ }
          if (choice === '0') return;
          paused = ev.matches || choice === '1';
          apply();
        });
      }
    } catch (e) { /* no matchMedia */ }
  });

  // ---------------------------------------- the typed link, for guests (§7.5)

  /* Signed-in customers get this href from Liquid. A guest's type lives on the
     device, so the anchors ship with the quiz URL — never a default type, never
     /collections/ornw — and are upgraded here once the type is known. The
     destination is everything approved for the type, not the type collection
     (snippets/sts-skin-types.liquid, shop_url; the filter value is case-sensitive). */
  /* Keep the attribute: every sts:state rewrites the link. A value is a
     shop_url template; {TYPE}/{type} are filled as in sts-home.js. */
  function fillTypeHrefs() {
    var type = root.getAttribute('data-sts-type');
    if (!type) return;
    var code = type.toUpperCase();
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var href = base.replace(/\/$/, '') + '/collections/all?filter.p.m.product_info.baumann_skin_type_info=' + code;
    $$('[data-sts-type-href]').forEach(function (a) {
      var tpl = a.getAttribute('data-sts-type-href');
      a.setAttribute('href', tpl ? tpl.replace(/\{TYPE\}/g, code).replace(/\{type\}/g, code.toLowerCase()) : href);
    });
  }

  // ------------------------------------------- readable ink on a partner colour

  /* assets/headerColors.js is partner brand DATA and is never edited from here.
     The theme's half of the decision is the ink it paints ON those colours, and
     every map there simply says `color: 'white'`. Measured, 7 of the 12 pairs
     that ship today are under WCAG AA 4.5:1 — the partner footers land at
     1.48:1 and 1.92:1, which is not text, it is texture — and every one of them
     clears AA against black. So: measure and choose, never recolour a brand.
     WCAG 2.x relative luminance, sRGB. */
  var INK_LIGHT = '#ffffff';
  var INK_DARK = '#000000';
  var AA_TEXT = 4.5;
  var AA_LARGE = 3;

  /* Logo plate gate: asset-notes/sts-chrome-js.md, "logo plate". */
  var LOGO_MIN_ON_WHITE = 3.68;
  var LOGO_PLATE_AT = LOGO_MIN_ON_WHITE / AA_LARGE;

  function srgbChannel(v) {
    v /= 255;
    return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
  }
  function luminance(rgb) {
    return 0.2126 * srgbChannel(rgb[0]) + 0.7152 * srgbChannel(rgb[1]) + 0.0722 * srgbChannel(rgb[2]);
  }
  function contrastRatio(a, b) {
    var la = a instanceof Array ? luminance(a) : a;
    var lb = b instanceof Array ? luminance(b) : b;
    return (Math.max(la, lb) + 0.05) / (Math.min(la, lb) + 0.05);
  }
  function round2(n) { return Math.round(n * 100) / 100; }

  var RGB_FN = /^rgba?\(\s*(\d+)[\s,]+(\d+)[\s,]+(\d+)/;

  /* Hex, rgb()/rgba() and the two names headerColors.js uses are read here;
     anything else a partner might be given one day (a name, hsl(), oklch()) is
     handed to the browser, the only correct parser for those. null when even
     that fails — an unreadable value is never guessed at, the partner's own
     declared colour is left alone. */
  function parseColour(value) {
    if (!value) return null;
    var s = String(value).trim().toLowerCase();
    if (s === 'white') return [255, 255, 255];
    if (s === 'black') return [0, 0, 0];
    var m = /^#([0-9a-f]{3,8})$/.exec(s);
    if (m) {
      var h = m[1];
      if (h.length === 3 || h.length === 4) {
        h = h.charAt(0) + h.charAt(0) + h.charAt(1) + h.charAt(1) + h.charAt(2) + h.charAt(2);
      }
      if (h.length < 6) return null;
      return [parseInt(h.slice(0, 2), 16), parseInt(h.slice(2, 4), 16), parseInt(h.slice(4, 6), 16)];
    }
    m = RGB_FN.exec(s);
    if (m) return [+m[1], +m[2], +m[3]];
    try {
      var probe = d.createElement('span');
      probe.style.color = value;
      if (!probe.style.color || !d.body) return null;   // the browser rejected it
      probe.style.display = 'none';
      d.body.appendChild(probe);
      var computed = window.getComputedStyle(probe).color;
      d.body.removeChild(probe);
      m = RGB_FN.exec(String(computed || '').trim().toLowerCase());
      return m ? [+m[1], +m[2], +m[3]] : null;
    } catch (e) { return null; }
  }

  /* White, black, or null for a third colour we have no business judging. */
  function inkOf(value) {
    var rgb = parseColour(value);
    if (!rgb) return null;
    if (rgb[0] === 255 && rgb[1] === 255 && rgb[2] === 255) return INK_LIGHT;
    if (!rgb[0] && !rgb[1] && !rgb[2]) return INK_DARK;
    return null;
  }

  /* Measure `bg` against white and black, return the ink that reads on it plus
     the numbers that chose it. Candidates, best first:
       1. `prefer`, a related state's ink — a label that flips black-to-white
          under the pointer is a worse button, so hover keeps the base ink where
          the base ink still clears AA on the hover colour;
       2. what headerColors.js declared, when it is white or black and clears AA
          — a partner whose own choice works is not overruled;
       3. whichever of the two measures higher.
     If none clears AA the higher one is used and `aa` is false: that palette is
     unreadable either way and must be said out loud, not papered over.

     That last branch cannot fire at 4.5:1, and it is worth knowing why. A
     colour's ratio against white is 1.05/(L+0.05) and against black is
     (L+0.05)/0.05, so the two always multiply to exactly 21 — the better of
     them is therefore never below sqrt(21), 4.58:1. Any parseable background
     has a readable ink. The branch stays for the case that is not a proof:
     `threshold` raised to AAA's 7:1, where 4.58 is genuinely short. */
  function pickInk(bg, declared, prefer) {
    var out = {
      bg: bg || null, declared: declared || null, fg: declared || null,
      white: null, black: null, ratio: null, aa: null, measured: false
    };
    var rgb = parseColour(bg);
    if (!rgb) return out;
    var l = luminance(rgb);
    out.white = round2(contrastRatio(l, 1));
    out.black = round2(contrastRatio(l, 0));
    out.measured = true;

    var best = out.white >= out.black ? INK_LIGHT : INK_DARK;
    var order = [prefer, inkOf(declared), best];
    for (var i = 0; i < order.length; i++) {
      if (!order[i]) continue;
      var r = order[i] === INK_LIGHT ? out.white : out.black;
      if (r >= AA_TEXT) {
        out.fg = order[i]; out.ratio = r; out.aa = true;
        return out;
      }
    }
    out.fg = best;
    out.ratio = best === INK_LIGHT ? out.white : out.black;
    out.aa = false;
    return out;
  }

  // ------------------------------------------ the text audit on those surfaces

  /* Scoring the painted CONTAINER answers the wrong question: its ink is only
     INHERITED, and every descendant that declares its own colour — a muted
     footer link class, a badge label, a CTA pill — opts out of the measurement
     unmeasured. The first version of this report did that and read
     `failing: []` on a black partner band while 27 visible nodes sat under AA,
     the header's primary CTA among them at 1.87:1. A gate that passes
     everything is worse than no gate.

     So score the LEAF TEXT NODES, each against the background it actually sits
     on: walk up to the nearest ancestor painting an opaque colour, and score
     only when that colour is one of the partner-painted surfaces. Text on a
     white card inside a partner bar is not this rule's business — nothing is
     ever scored against a background it does not sit on. */
  var AA_LARGE = 3;                 // WCAG 1.4.3 large text
  var LARGE_PX = 24;                // 18pt
  var LARGE_BOLD_PX = 18.66;        // 14pt, >= 700
  var MAX_NODES = 600;              // a hard ceiling on a storefront page
  var SKIP_TAGS = /^(SCRIPT|STYLE|NOSCRIPT|TEMPLATE|OPTION|SVG|IFRAME)$/;
  var RGBA_FN = /^rgba?\(([^)]+)\)/;

  /* getComputedStyle returns a live object, so one per element is safe to keep,
     and ancestors are re-walked constantly. */
  var styleCache = typeof WeakMap === 'function' ? new WeakMap() : null;
  function styleOf(el) {
    if (styleCache && styleCache.has(el)) return styleCache.get(el);
    var cs = window.getComputedStyle(el);
    if (styleCache) styleCache.set(el, cs);
    return cs;
  }

  function parseRgba(value) {
    var m = RGBA_FN.exec(String(value || '').trim().toLowerCase());
    if (!m) return null;
    var p = m[1].split(/[\s,\/]+/).filter(Boolean).map(parseFloat);
    if (p.length < 3 || p[0] !== p[0]) return null;
    return [p[0], p[1], p[2], p.length > 3 && p[3] === p[3] ? p[3] : 1];
  }
  function over(fg, bg) {       // source-over, fg's alpha onto an opaque bg
    var a = fg[3];
    return [fg[0] * a + bg[0] * (1 - a), fg[1] * a + bg[1] * (1 - a),
      fg[2] * a + bg[2] * (1 - a), 1];
  }
  function rgbText(c) {
    return 'rgb(' + Math.round(c[0]) + ', ' + Math.round(c[1]) + ', ' + Math.round(c[2]) + ')';
  }
  function sameRgb(a, b) {
    return !!a && !!b && Math.round(a[0]) === Math.round(b[0]) &&
      Math.round(a[1]) === Math.round(b[1]) && Math.round(a[2]) === Math.round(b[2]);
  }

  /* The background the text really sits on: nearest opaque ancestor colour,
     with any translucent layers above it composited in. null when an image or
     gradient intervenes — unmeasurable, so counted as skipped, never passed. */
  function resolveBg(el) {
    var over_ = [], node = el, hops = 0;
    while (node && node.nodeType === 1 && hops++ < 32) {
      var cs = styleOf(node);
      if (cs.backgroundImage && cs.backgroundImage !== 'none') return null;
      var c = parseRgba(cs.backgroundColor);
      if (c && c[3] > 0) {
        if (c[3] >= 1) {
          var out = c;
          for (var i = over_.length - 1; i >= 0; i--) out = over(over_[i], out);
          return { rgb: out, base: c, el: node };
        }
        over_.push(c);
      }
      node = node.parentElement;
    }
    return null;
  }

  /* Enough of the DOM to find the node again in devtools, without an nth-child
     path that the next section edit invalidates. */
  function selectorFor(el, stop) {
    var parts = [], node = el, depth = 0;
    while (node && node.nodeType === 1 && depth++ < 4) {
      var s = node.tagName.toLowerCase();
      if (node.id) { parts.unshift('#' + node.id); break; }
      var cls = (node.getAttribute('class') || '').split(/\s+/).filter(Boolean).slice(0, 3);
      if (cls.length) s += '.' + cls.join('.');
      else {
        var at = node.attributes, j;
        for (j = 0; j < at.length; j++) {
          if (at[j].name.indexOf('data-sts') === 0) { s += '[' + at[j].name + ']'; break; }
        }
      }
      parts.unshift(s);
      if (node === stop) break;    // the painted root itself, when the text is its own child
      node = node.parentElement;
    }
    return parts.join('>');
  }

  /* One pass over the text inside the painted surfaces: `paints` are the
     partner colours applied, `roots` the elements they were applied to. The
     walk never leaves those subtrees, so the cost is the chrome, not the page. */
  function auditText(roots, paints, report) {
    var t0 = 0;
    try { t0 = performance.now(); } catch (e) { /* no perf clock */ }
    report.nodes = [];
    report.failing = [];
    report.skipped = 0;
    report.scanned = 0;

    for (var r = 0; r < roots.length; r++) {
      var walker = d.createTreeWalker(roots[r], NodeFilter.SHOW_TEXT, null, false);
      var n;
      while ((n = walker.nextNode())) {
        if (report.scanned >= MAX_NODES) break;
        var text = (n.nodeValue || '').replace(/\s+/g, ' ').trim();
        if (!text) continue;
        var el = n.parentElement;
        if (!el || SKIP_TAGS.test(el.tagName)) continue;

        var cs = styleOf(el);
        if (cs.visibility === 'hidden' || cs.display === 'none') continue;
        if (!el.getClientRects().length) continue;   // not rendered: nothing to read
        report.scanned++;

        var fg = parseRgba(cs.color);
        var bg = resolveBg(el);
        if (!fg || !bg) { report.skipped++; continue; }
        /* Which partner surface it is. Two of them can carry the SAME colour —
           RT202's bar and its buttons are both #000 — so a colour match alone
           would label a hero CTA "header". The element that actually painted
           the background settles it when it is one of the painted elements. */
        var surface = null;
        for (var p = 0; p < paints.length; p++) {
          if (!sameRgb(paints[p].rgb, bg.base)) continue;
          if (!surface) surface = paints[p].name;
          if (paints[p].els.indexOf(bg.el) > -1) { surface = paints[p].name; break; }
        }
        if (!surface) continue;    // sits on some other surface; not ours to judge

        var ink = fg[3] < 1 ? over(fg, bg.rgb) : fg;
        var size = parseFloat(cs.fontSize) || 16;
        var weight = cs.fontWeight === 'bold' ? 700 : (parseInt(cs.fontWeight, 10) || 400);
        var large = size >= LARGE_PX || (size >= LARGE_BOLD_PX && weight >= 700);
        var ratio = round2(contrastRatio([ink[0], ink[1], ink[2]], [bg.rgb[0], bg.rgb[1], bg.rgb[2]]));
        var rec = {
          surface: surface,
          selector: selectorFor(el, roots[r]),
          text: text.length > 44 ? text.slice(0, 43) + '…' : text,
          color: rgbText(ink),
          background: rgbText(bg.rgb),
          fontPx: Math.round(size * 10) / 10,
          weight: weight,
          large: large,
          threshold: large ? AA_LARGE : AA_TEXT,
          ratio: ratio,
          pass: ratio >= (large ? AA_LARGE : AA_TEXT),
          el: el
        };
        report.nodes.push(rec);
        if (!rec.pass) {
          report.failing.push(rec);
          try { el.setAttribute('data-sts-text-fail', ratio.toFixed(2)); } catch (e) { /* frozen node */ }
        }
      }
    }
    try { report.ms = round2(performance.now() - t0); } catch (e) { /* no perf clock */ }
    report.ready = true;
    return report;
  }

  function warnText(report) {
    if (!report.failing.length) return;
    try {
      console.warn('[sts] affiliate ' + report.code + ': ' + report.failing.length + ' of ' +
        report.nodes.length + ' text nodes on partner surfaces are under WCAG AA — ' +
        report.failing.slice(0, 12).map(function (f) {
          return f.selector.split('>').pop() + ' ' + f.ratio + ':1 (needs ' + f.threshold + ')';
        }).join('; ') + (report.failing.length > 12 ? '; …' : '') +
        '. All of them: console.table(window.STS.affiliateContrast.failing).');
    } catch (e) { /* never break a page */ }
  }

  // ------------------------------------------------- the header logo plate

  /* The chip under the header mark (see LOGO_PLATE_AT). Not affiliate work any
     more: since the decision below, the bar carries the STS colour on every
     visit, so this runs for every visitor, coded or not, and decides off the
     colour the browser actually resolved. CSS does the painting. null when an
     image or a gradient is in the way — unmeasurable is left alone, never
     guessed at. */
  function applyLogoPlate() {
    if (!header) return null;
    var bg = null;
    try { bg = resolveBg(header); } catch (e) { bg = null; }
    if (!bg) return null;
    var band = [bg.rgb[0], bg.rgb[1], bg.rgb[2]];
    var vsWhite = round2(contrastRatio(band, [255, 255, 255]));
    var plate = vsWhite > LOGO_PLATE_AT;
    if (plate) header.setAttribute('data-sts-logo-plate', '');
    else header.removeAttribute('data-sts-logo-plate');
    return (STS.logoPlate = {
      plate: plate,
      band: rgbText(band),
      bandVsWhite: vsWhite,
      gate: round2(LOGO_PLATE_AT),
      refOnWhite: LOGO_MIN_ON_WHITE,
      keeps: round2(LOGO_MIN_ON_WHITE / vsWhite)
    });
  }

  // --------------------------------------------------- affiliate colours (§7.4)

  /* Partner identity carries on the LOGO, and on nothing structural.

     Luis's call on 2026-09-19, after looking at ?code=DRB on the preview: the
     header band, the nav row under it, the footer bar and every primary CTA
     keep the STS navy chrome and the --sts-btn ramp exactly as an unbranded
     visit gets them. What still says who the partner is: the logo swap in the
     header, the provider band lower down, and the partner's own announcement
     messages. This is a deliberate departure from decision 03-Q4 ("preserve
     every affiliate behaviour"), and the reason is the page it replaced — one
     coded visit carried TWO button colours, the partner's taupe above the fold
     and the navy below it, on top of a taupe bar and a grey-brown footer.

     It is a reduction of what the painter TARGETS, not a removal of the
     painter. The three maps in assets/headerColors.js, the ink measurement
     (pickInk / window.STS.contrast), the data-sts-ink / data-sts-contrast
     marks and the text audit are all intact, and the surface list is simply
     opt-in now: an element carrying data-sts-affiliate-paint="header",
     "footer" or "button" takes that map's colour, measured, with its hover
     pair. Nothing in the theme carries the attribute today, so a coded visit
     paints nothing. The provider band (W-A1b) is the one surface where a
     partner colour would still read as the partner's own rather than as a
     recoloured interface — putting the attribute on
     sections/sts-provider-band.liquid is the whole of the work if that is ever
     wanted, and everything below already measures and audits it. */
  var PAINT_ATTR = 'data-sts-affiliate-paint';

  function applyAffiliateColours() {
    var code = root.getAttribute('data-sts-affiliate');
    if (!code) return;
    var maps = {
      header: (window.headerColors && window.headerColors[code]) || null,
      footer: (window.footerColors && window.footerColors[code]) || null,
      button: (window.buttonColors && window.buttonColors[code]) || null
    };
    if (!maps.header && !maps.footer && !maps.button) return;

    /* What QA reads instead of eyeballing a screenshot. `surfaces` is the ink
       DECISION per painted surface; `nodes` and `failing` are the audit of the
       text that actually landed on them, which is the only one of the two that
       can say the page is readable. `ready` is false until that pass has run,
       so an empty `failing` is never mistaken for a clean page. `chrome` is the
       flag for the decision above — 'sts' means the bar, the nav row, the
       footer and the CTAs were left on the STS ramp — and `logo` carries the
       plate decision made against the band they kept. */
    var report = (STS.affiliateContrast = {
      code: code, threshold: AA_TEXT, largeThreshold: AA_LARGE,
      chrome: 'sts', logo: STS.logoPlate || null,
      surfaces: {}, unreadable: [], nodes: [], failing: [],
      scanned: 0, skipped: 0, ms: null, ready: false
    });
    var paints = [];      // the partner colours actually applied
    var roots = [];       // the elements they were applied to
    function record(name, m, count) {
      m.painted = count;
      report.surfaces[name] = m;
      if (m.aa === false && report.unreadable.indexOf(name) < 0) report.unreadable.push(name);
    }
    function painted(name, colour, els) {
      var rgb = parseColour(colour);
      if (rgb && els.length) paints.push({ name: name, rgb: rgb, css: colour, els: els });
      els.forEach(function (el) { if (roots.indexOf(el) < 0) roots.push(el); });
    }
    /* The same two numbers on the element, readable straight off the DOM. */
    function mark(el, m, suffix) {
      if (!m.measured) return;
      el.setAttribute('data-sts-ink' + suffix, m.fg === INK_LIGHT ? 'light' : 'dark');
      el.setAttribute('data-sts-contrast' + suffix, m.ratio.toFixed(2));
      if (m.aa === false) el.setAttribute('data-sts-contrast-fail' + suffix, '');
    }

    /* Group the opt-in elements by the map each one asked for, so a single
       measurement per map covers however many elements took it. A value that
       names no map paints nothing rather than guessing at a palette. */
    var groups = {};
    $$('[' + PAINT_ATTR + ']').forEach(function (el) {
      var name = (el.getAttribute(PAINT_ATTR) || '').trim().toLowerCase();
      if (!maps[name]) return;
      (groups[name] || (groups[name] = [])).push(el);
    });

    Object.keys(groups).forEach(function (name) {
      var palette = maps[name];
      var els = groups[name];
      /* The hover pair. Every map in assets/headerColors.js carries
         hoverBackground and hoverColor, and because --sts-aff-bg lands with
         !important a painted control with no hover value would be the one thing
         on the page that does not answer the pointer. Fall back to the base
         colour so it still reads as the same control. */
      var hoverBg = palette.hoverBackground || palette.background;
      var baseInk = pickInk(palette.background, palette.color);
      var hoverInk = pickInk(hoverBg, palette.hoverColor || palette.color,
        baseInk.measured ? baseInk.fg : null);
      els.forEach(function (el) {
        el.style.setProperty('--sts-aff-bg', palette.background);
        el.style.setProperty('--sts-aff-fg', baseInk.fg);
        el.style.setProperty('--sts-aff-bg-hover', hoverBg);
        el.style.setProperty('--sts-aff-fg-hover', hoverInk.fg);
        el.setAttribute('data-sts-affiliate-colored', '');
        mark(el, baseInk, '');
        mark(el, hoverInk, '-hover');
      });
      record(name, baseInk, els.length);
      record(name + 'Hover', hoverInk, els.length);
      painted(name, palette.background, els);
    });

    if (report.unreadable.length) {
      try {
        console.warn('[sts] affiliate ' + code + ': no ink clears WCAG AA ' + AA_TEXT +
          ':1 on ' + report.unreadable.join(', ') + '. The best available was used; the ' +
          'palette in assets/headerColors.js needs a merchandising fix. Numbers: ' +
          'window.STS.affiliateContrast.');
      } catch (e) { /* never break a page */ }
    }

    /* A painted element nested inside another painted one is already inside
       that walk. */
    roots = roots.filter(function (el) {
      return !roots.some(function (other) { return other !== el && other.contains(el); });
    });

    /* Reading colours means reading layout, so it waits for an idle frame
       rather than lengthening the boot the partner's visitor is waiting on.
       `rescan` re-runs it after something opens — the drawer, the mega panel,
       the badge — whose text is not rendered at boot. */
    function run() {
      try { auditText(roots, paints, report); warnText(report); }
      catch (e) { report.error = String(e); }
      return report;
    }
    report.rescan = run;
    if (!paints.length || !roots.length) { report.ready = true; return; }
    if (window.requestIdleCallback) window.requestIdleCallback(run, { timeout: 2000 });
    else setTimeout(run, 0);
  }

  // -------------------------------------------------- the check-in dismiss

  on($('[data-sts-strip-dismiss]'), 'click', function () {
    if (STS.snoozeCheckin) STS.snoozeCheckin(30);
    else root.setAttribute('data-sts-strip', 'dismissed');
  });

  // ------------------------------------------------------------- analytics

  /* Spec 09 §6.9 events 2, 3, 5 and 6, for every quiz link and every sign-in
     link in the chrome. One delegated listener, so the links need no hooks of
     their own and a drawer or strip re-rendered in the theme editor is still
     covered. It only observes: nothing here prevents or delays a navigation.
     Which of the three quiz events a tap is (start, resume, retake) is decided
     in assets/sts-track.js, the same place every page asks. */
  function track(name, params) {
    try { if (typeof window.stsTrack === 'function') window.stsTrack(name, params); } catch (e) { /* never break a page */ }
  }
  function quizClick(placement, href, kind) {
    try {
      var T = window.STSTrack;
      if (T && typeof T.quizClick === 'function') return T.quizClick(placement, href, kind);
    } catch (e) { /* never break a page */ }
    return false;
  }

  on(d, 'click', function (ev) {
    var a = ev.target && ev.target.closest && ev.target.closest('a[href]');
    if (!a) return;
    var href = a.getAttribute('href') || '';

    var strip = a.closest('[data-sts-strip]:not(html)');
    if (strip) {
      var variant = a.closest('.sts-strip__variant');
      var cls = variant ? variant.className : '';
      if (/--qpartial/.test(cls)) quizClick('strip', href, 'resume');
      else if (/--checkin/.test(cls)) quizClick('strip', href, 'retake');
      else if (/--qminus|--guest/.test(cls) && /\/account\/(login|register)/.test(href)) {
        track('sts_signin_banner_click', {
          action: href.indexOf('/account/register') > -1 ? 'create_account' : 'sign_in',
          strip: /--guest/.test(cls) ? 'guest_typed' : 'qminus'
        });
      }
      return;
    }

    /* :not(html) because <html> carries data-sts-drawer and data-sts-strip
       too, as open/dismissed flags. */
    var placement = a.closest('[data-sts-badge]:not(html)') ? 'badge'
      : a.closest('[data-sts-drawer]:not(html)') ? 'menu'
      : a.closest('[data-sts-header]:not(html)') ? 'nav'
      : a.closest('[data-sts-footer]:not(html)') ? 'footer'
      : a.closest('[data-sts-ann]:not(html)') ? 'banner'
      : null;
    if (placement) quizClick(placement, href);
  }, true);

  // --------------------------------------------------------------- exports

  /* The one implementation of the ink rule; header-color-change.js reuses it.
     Load order: asset-notes/sts-chrome-js.md, "STS.contrast export". */
  STS.contrast = {
    aa: AA_TEXT,
    light: INK_LIGHT,
    dark: INK_DARK,
    parse: parseColour,
    luminance: luminance,
    ratio: contrastRatio,
    pick: pickInk
  };

  STS.chrome = {
    openDrawer: openDrawer,
    closeDrawer: closeDrawer,
    openSearch: function () { setSearch(true); },
    closeSearch: function () { setSearch(false); },
    openMega: openMega,
    close: function () { closeDrawer(); closeMega(); closeBadge(); setSearch(false); }
  };

  /* ---- the header cart count ----
     Why two event sources, and why the count skips the app's auto-added
     reward line: asset-notes/sts-chrome-js.md, "The header cart count".
     ⚠ Tied to the app's property name, as sts-header.liquid is. */
  function stsAutoLine(p) {
    /* The upsell app's own lines: any property key ending in _autoAddWidgetId
       or _gwpWidgetId, or _lcu_condition_id. Same rule as
       snippets/sts-line-auto.liquid. */
    if (!p) return false;
    for (var k in p) {
      if (!Object.prototype.hasOwnProperty.call(p, k)) continue;
      if (k === '_lcu_condition_id' || /_(autoAddWidgetId|gwpWidgetId)$/.test(k)) return true;
    }
    return false;
  }
  function cartBadgeCount(cart) {
    var n = 0;
    (cart.items || []).forEach(function (line) {
      if (line && stsAutoLine(line.properties)) return;
      n += (line && line.quantity) || 0;
    });
    return n;
  }
  /* v6.1 §6: "99+" above 99. The attribute keeps the real number. */
  function paintCount(n) {
    $$('[data-cart-count]').forEach(function (el) {
      /* The attribute as well as the text: the attribute is what hides the
         badge at zero, the text is what a shopper and a screen reader read. */
      el.setAttribute('data-cart-count', String(n));
      el.textContent = n > 99 ? '99+' : String(n);
    });
  }
  STS.chrome.paintCount = paintCount;
  function paintCartCount(cart) {
    if (!cart || typeof cart.item_count !== 'number') return;
    var n = cartBadgeCount(cart);
    /* On a phone assets/sts-cart-fx.js may hold the old number until its dot
       lands on the menu's Cart icon; it then paints through paintCount. */
    if (STS.cartHold && STS.cartHold(n)) return;
    paintCount(n);
  }
  ['sts:cart:updated', 'theme:cart:change'].forEach(function (name) {
    d.addEventListener(name, function (e) { paintCartCount(e && e.detail && e.detail.cart); });
  });
  d.addEventListener('upsell:cart-updated', function (e) {
    paintCartCount(e && e.detail && e.detail.newCart);
    lcuWatch();
  });

  /* ---- the LlamaCart drawer: two text fixes and the empty-state actions ----
     Visual only; no cart, checkout or discount behaviour. Why a scoped observer,
     why each fix is safe against the app's re-renders, and the app classes this
     reads: asset-notes/sts-chrome-js.md, "LlamaCart drawer (2026-09-21)". */
  var lcuSeen = null;
  var lcuQueued = false;
  function lcuQueue() {
    if (lcuQueued) return;
    lcuQueued = true;
    (window.requestAnimationFrame || setTimeout)(lcuPass);
  }
  function lcuWatch() {
    var el = d.getElementById('lcu-llama-cart');
    if (el && el !== lcuSeen && window.MutationObserver) {
      lcuSeen = el;
      new MutationObserver(lcuQueue).observe(el, { childList: true, subtree: true, characterData: true });
    }
    lcuQueue();
  }
  function lcuPass() {
    lcuQueued = false;
    var drawer = d.getElementById('lcu-llama-cart');
    if (!drawer) return;
    /* The gift message's amount comes from a formatter hard-coded to drop
       trailing zeros: "$29.2" -> "$29.20". Idempotent. */
    $$('.lcu__gwp__head__title .app__limit', drawer).forEach(function (b) {
      var t = b.textContent;
      var f = t.replace(/\d\.\d(?!\d)/g, function (m) { return m + '0'; });
      if (f !== t) b.textContent = f;
    });
    /* v6.1 §6 drawer footer: shipping and tax are always "Calculated at
       checkout", and a way to the full cart page, where the per-product
       Subscribe & save lives. Appended LAST (the app keys its own children;
       CSS `order` places them); the link only when the app draws no cart
       button of its own (LlamaCart "includeCartPageBtn"). */
    var foot = $('.lcu__drawer__footer', drawer);
    if (foot && !$('.sts-lcu-sum', foot)) {
      var sum = d.createElement('div');
      sum.className = 'sts-lcu-sum';
      sum.innerHTML = '<p><span>Shipping</span><span>Calculated at checkout</span></p><p><span>Tax</span><span>Calculated at checkout</span></p>';
      foot.appendChild(sum);
      if (!$('a[href$="/cart"]', foot)) {
        var full = d.createElement('a');
        full.className = 'sts-lcu-full';
        full.href = (window.theme && window.theme.routes && window.theme.routes.cart) || '/cart';
        full.textContent = 'View full cart';
        foot.appendChild(full);
      }
    }
    lcuLines(drawer, foot);
    /* v6.3 copy, as snippets/cart-empty.liquid: asset-notes/sts-chrome-js.md. */
    lcuText($('.lcu__drawer__title', drawer), /^(\s*)shopping cart(\s*)$/i, '$1Your cart$2');
    var empty = $('.lcu__empty-state', drawer);
    if (!empty) return;
    var etitle = $('.lcu__empty-state__title', empty);
    lcuText(etitle, /your cart is empty\.?/i, 'Your cart is empty');
    var type = (root.getAttribute('data-sts-type') || '').toUpperCase();
    $$('[data-sts-lcu-type]', empty).forEach(function (c) { if (c.textContent !== type) c.textContent = type; });
    $$('[data-sts-lcu-match]', empty).forEach(function (a) {
      if (type) a.href = typeShopUrl(type);
    });
    if ($('.sts-lcu-empty', empty)) return;
    var base = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/$/, '');
    var copy = d.createElement('div');
    copy.className = 'sts-lcu-empty-copy';
    copy.innerHTML = '<p data-sts-show="qminus">Take the free quiz to see which products are right for your skin.</p>' +
      '<p data-sts-show="qpartial">Finish the free quiz to see which products are right for your skin.</p>' +
      '<p class="sts-only-typed">Start with your <span data-sts-lcu-type></span> routine, or ' +
      '<a class="sts-lcu-empty__match" data-sts-lcu-match href="' + base + '/pages/skin-type-quiz">shop products matched to your skin type</a>.</p>';
    empty.appendChild(copy);
    var row = d.createElement('div');
    row.className = 'sts-lcu-empty';
    function pill(cls, href, label) {
      var a = d.createElement('a');
      a.className = 'sts-btn sts-btn--sm ' + cls;
      a.href = base + href;
      a.textContent = label;
      row.appendChild(a);
      return a;
    }
    pill('sts-btn--primary sts-only-untyped', '/pages/skin-type-quiz', '').innerHTML =
      '<span data-sts-show="qminus">Take the quiz</span><span data-sts-show="qpartial">Finish the quiz</span>';
    pill('sts-btn--primary sts-only-typed', '/pages/skin-type-results', 'See my routine').setAttribute('data-sts-routine-link', '');
    /* No theme "Continue shopping" here (2026-10-13, Luis): LlamaCart draws
       its own Continue Shopping button (app setting, link = Shop Skincare
       Products) and is the one we keep. The theme's pill used to be added
       only when the app's link was missing, but the app renders that link
       after this pass runs, so both showed. */
    empty.appendChild(row);
    lcuPass();
  }
  /* ---- the LlamaCart drawer: plan names and the free-shipping countdown ----
     Live QA 2026-10-12. Two subscription lines of one product read the same
     in the drawer, so each line gets its selling plan ("Delivery every 30
     days") under the variant, as /cart and checkout show it. And the footer
     gets the countdown /cart shows ("Spend $21 more for free shipping."), in
     the copy and the market amount of the theme's own drawer
     (snippets/cart-drawer.liquid renders [data-cart-progress] on every page,
     unopened, only while the setting is on): read from there, never typed
     here. Rows are matched on the app's data-variant-key, which is the cart
     line key; the cart is re-read when the rows stop matching it. */
  var lcuCartData = null;
  var lcuReading = false;
  var lcuSig = '';
  function lcuReadCart(sig) {
    if (lcuReading || !window.fetch) return;
    lcuReading = true;
    var base = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/');
    window.fetch(base + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { lcuReading = false; if (c) { lcuCartData = c; lcuSig = sig; lcuQueue(); } },
        function () { lcuReading = false; });
  }
  function lcuMoney(cents, cur) {
    var v = cents / 100;
    var t;
    try { t = new Intl.NumberFormat(root.lang || 'en', { style: 'currency', currency: cur || 'USD' }).format(v); }
    catch (e) { t = '$' + v.toFixed(2); }
    return t.replace(/[.,]00(?!\d)/, '');
  }
  function lcuLines(drawer, foot) {
    var rows = $$('.lcu__drawer__item[data-variant-key]', drawer);
    var sig = rows.map(function (r) {
      var q = $('input[name="quantity"]', r);
      var p = $('.lcu__product-prices', r);
      return r.getAttribute('data-variant-key') + 'x' + (q ? q.value : '') + (p ? p.textContent : '');
    }).join('|');
    if (sig !== lcuSig) { lcuReadCart(sig); }
    var c = lcuCartData;
    if (!c) return;
    var byKey = {};
    (c.items || []).forEach(function (it) { byKey[it.key] = it; });
    rows.forEach(function (r) {
      var it = byKey[r.getAttribute('data-variant-key')];
      var a = it && it.selling_plan_allocation;
      var name = a && a.selling_plan ? a.selling_plan.name : '';
      var group = $('.lcu__drawer__title-group', r);
      var tag = $('.sts-lcu-plan', r);
      if (!name || !group) { if (tag && tag.parentNode) tag.parentNode.removeChild(tag); return; }
      if (!tag) { tag = d.createElement('span'); tag.className = 'sts-lcu-plan'; group.appendChild(tag); }
      if (tag.textContent !== name) tag.textContent = name;
    });
    var src = $('#drawer-cart [data-cart-progress]');
    var ship = foot && $('.sts-lcu-ship', foot);
    if (!foot || !src || !c.item_count) { if (ship && ship.parentNode) ship.parentNode.removeChild(ship); return; }
    var rate = Number(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1;
    var left = Math.round(Number(src.getAttribute('data-limit')) * 100 * rate) - c.total_price;
    var text;
    if (left > 0) {
      var tpl = $('.cart__message-default', src);
      var span = tpl && tpl.cloneNode(true);
      var amt = span && $('[data-left-to-spend]', span);
      if (amt) amt.textContent = lcuMoney(left, c.currency);
      text = span ? span.textContent.replace(/\s+/g, ' ').trim() : '';
    } else {
      var ok = $('.cart__message-success', src);
      text = ok ? ok.textContent.replace(/\s+/g, ' ').trim() : '';
    }
    if (!text) { if (ship && ship.parentNode) ship.parentNode.removeChild(ship); return; }
    if (!ship) { ship = d.createElement('p'); ship.className = 'sts-lcu-ship'; foot.appendChild(ship); }
    if (ship.textContent !== text) ship.textContent = text;
    ship.classList.toggle('is-success', left <= 0);
  }
  function lcuText(el, re, to) {
    var walk = el && d.createTreeWalker(el, 4);
    while (walk && walk.nextNode()) {
      var n = walk.currentNode;
      var v = n.data.replace(re, to);
      if (v !== n.data) n.data = v;
    }
  }
  function typeShopUrl(type) {
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return base.replace(/\/$/, '') + '/collections/all?filter.p.m.product_info.baumann_skin_type_info=' + type;
  }
  d.addEventListener('lcu:cart:toggle', lcuWatch);
  d.addEventListener('sts:state', lcuQueue);
  /* The header bag opens LlamaCart via its [data-lcu-smart-cart-trigger]
     hook. Until the drawer has rendered, keep the app's listener off the
     click so the href navigates instead of going inert (#234). */
  window.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-lcu-smart-cart-trigger]');
    if (a && !$('#lcu-llama-cart .lcu__drawer__content')) e.stopPropagation();
  }, true);

  // ------------------------------------------------------------------ boot

  fillTypeHrefs();
  applyLogoPlate();
  applyAffiliateColours();
  lcuWatch();
  /* The head resolver dispatches sts:state synchronously, long before this
     file runs, but assets/sts-state.js can refresh it (a pending result
     attached, a snooze written), so the type-dependent work re-runs. */
  d.addEventListener('sts:state', fillTypeHrefs);
}());
